function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40,58.56c-10.31,0-18.7-8.39-18.7-18.7v-12.95c0-10.31,8.39-18.7,18.7-18.7s18.7,8.39,18.7,18.7v12.95c0,10.31-8.39,18.7-18.7,18.7ZM40,11.2c-8.66,0-15.7,7.04-15.7,15.7v12.95c0,8.66,7.04,15.7,15.7,15.7s15.7-7.04,15.7-15.7v-12.95c0-8.66-7.04-15.7-15.7-15.7Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40,64.09c-13.53,0-24.53-11.01-24.53-24.53v-3.95c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v3.95c0,11.87,9.66,21.53,21.53,21.53s21.54-9.66,21.54-21.53v-3.95c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v3.95c0,13.53-11.01,24.53-24.54,24.53Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "cls-1",
  d: "M30.37,26.85h-6.64c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.64c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M30.37,32.2h-6.64c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.64c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M30.37,37.55h-6.64c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.64c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M30.37,42.9h-6.64c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.64c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
})), React.createElement("g", null, React.createElement("path", {
  className: "cls-1",
  d: "M56.27,26.85h-6.63c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.63c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M56.27,32.2h-6.63c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.63c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M56.27,37.55h-6.63c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.63c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M56.27,42.9h-6.63c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.63c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  x: 38.5,
  y: 62.59,
  width: 3,
  height: 7.71
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M56.27,71.8H23.73c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h32.54c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "static/media/GameShows-inactive.5e63505c.svg";
export { SvgComponent as ReactComponent };